import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'

const savedLang = localStorage.getItem('i18nextLng') || 'en';
const isRtl = savedLang === 'ar';
document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

const bootstrapPromise = isRtl
  ? import('bootstrap/dist/css/bootstrap.rtl.min.css')
  : import('bootstrap/dist/css/bootstrap.min.css');

bootstrapPromise.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
});
